// extracted by mini-css-extract-plugin
export default {"hiker":"HikerCharacter_hiker__KPrhL"};